import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classes from "./coachdetailcard.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { ArrowUpRightBlue, coachDemoImg } from "../../constant/imagePath";
import { AiFillStar } from "react-icons/ai";
import { TiLocation } from "react-icons/ti";
import moment from "moment";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import CoachAvailibility from "../../components/Modals/StudentFlow/CoachDetails/CoachAvailibility/CoachAvailibility";

export const CoachDetailCard = ({
  userData,
  isShowTiming,
  searchDateArray,
  width_B,
}) => {
  const [timingHtml, setTimingHtml] = useState([]);
  //modal State
  const [showCoachAvail, setShowCoachAvail] = useState(false);

  const CreateHTML = () => {
    let Data = [];
    let oldState = "";
    let oldStateIndex = null;

    searchDateArray.map((item, index) => {
      userData.timing.map((innerItem, innerIndex) => {
        if (
          index < 4 &&
          moment(item).format("YYYY-MM-DD") ==
            moment(innerItem?.date).format("YYYY-MM-DD") &&
          innerIndex < 4
        ) {
          oldStateIndex = index;
          Data.push(
            <div
              style={{ width: !!width_B && width_B }}
              className={`col-md-3 ${[classes.timingSpanContainer].join(" ")}`}
            >
              {innerItem.time.map((e, i) => {
                if (i < 3) {
                  return (
                    <div
                      className={`${[
                        classes.timingSpan,
                        classes.timingSpanBorder,
                      ].join(" ")}`}
                      style={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.p2,
                        border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                        padding: "8px",
                        height: "36px",
                      }}
                    >
                      {e}
                    </div>
                  );
                }
              })}
            </div>
          );
        } else if (
          moment(item).format("YYYY-MM-DD") <
            moment(innerItem?.date).format("YYYY-MM-DD") &&
          oldState !== item &&
          oldStateIndex !== index &&
          innerIndex < 4
        ) {
          console.log({ oldState, oldStateIndex });
          oldState = item;
          oldStateIndex = null;
          Data.push(
            <div
              className={`col-md-3 ${[classes.timingSpanContainer].join(" ")}`}
            >
              <div className={`${[classes.timingSpan].join(" ")}`}></div>
            </div>
          );
        }
      });
    });

    setTimingHtml(Data);
  };
  useEffect(() => {
    CreateHTML();
  }, []);

  return (
    <Container
      fluid
      className={` p-0 ${[classes.CoachDetailCard].join(" ")}`}
      style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
    >
      <Row className={`g-0 ${[classes.customRow].join(" ")}`}>
        {/* <Col md={12} className={`${[classes.customCol].join(" ")}`}> */}
        <Col className="cus_div_b" md={isShowTiming == false ? 10 : 6}>
          <div className={classes.imgWithData}>
            <div className={` ${[classes.innerContainer1].join(" ")}`}>
              <img
                src={userData?.photo}
                alt=""
                className={`${[classes.profilePhoto].join(" ")}`}
              />
            </div>

            <div
              className={`
            ${[
              classes.innerContainer2,
              isShowTiming == false && classes.fullContainer2,
            ].join(" ")}`}
            >
              <span
                className={`${[classes.userName].join(" ")}`}
                style={{
                  ...Fonts.h5,
                  color: Colors.neutralShadesOfNero,
                  letterSpacing: "-1%",
                }}
              >
                {userData?.displayName}
              </span>
              <div className={`${[classes.addressAndType].join(" ")}`}>
                <TiLocation color={"#717171"} />
                <span className={`${[classes.distance].join(" ")}`}>
                  {"0.6 m away"}
                </span>
                <span
                  className={`${[classes.break].join(" ")}`}
                  style={{ background: Colors.neutralShadesOfPinkSwan }}
                />
                <span className={`${[classes.sport].join(" ")}`}>
                  {userData?.sport}
                </span>
              </div>
              <span className={`${[classes.description].join(" ")}`}>
                {userData?.aboutMe}
              </span>

              <div className={`${[classes.ratingAndPrice].join(" ")}`}>
                <AiFillStar color={Colors.mainShadeOfRed} />
                <span
                  className={`${[classes.rating].join(" ")}`}
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.h7,
                    lineHeight: "24px",
                    fontFamily: "inter-600",
                    letterSpacing: "-1%",
                  }}
                >
                  {(userData?.rating).toFixed(1)}
                </span>
                <span
                  className={`${[classes.break].join(" ")}`}
                  style={{ background: Colors.neutralShadesOfPinkSwan }}
                />

                <span
                  className={`${[classes.price].join(" ")}`}
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.h6,
                    letterSpacing: "-0.01em",
                  }}
                >
                  ${userData?.price}/hr
                </span>
              </div>
            </div>
          </div>
        </Col>

        {isShowTiming && (
          <Col
            md={6}
            className={`dnone_b ${[classes.innerContainer3].join(" ")}`}
          >
            <Row className={`gy-0 ${[classes.timingRow].join(" ")}`}>
              {timingHtml.map((e, i) => e)}
            </Row>
            <div className={classes.viewAllAvailabilityBox}>
              <LinkButtonWithIcon
                onClick={() => setShowCoachAvail(true)}
                primary={true}
                text={"View all availability"}
                rightIcon={ArrowUpRightBlue}
                iconStyle={{ marginLeft: "0px" }}
              />
            </div>
          </Col>
        )}
        {/* </Col> */}
      </Row>
      <style jsx>{`
        .${classes.innerContainer2} span {
          color: ${Colors.neutralShadesOfDimGray};
          font-family: ${Fonts.p2.fontFamily};
          font-size: ${Fonts.p2.fontSize};
          line-height: ${Fonts.p2.lineHeight};
        }
      `}</style>

      <CoachAvailibility show={showCoachAvail} setShow={setShowCoachAvail} />
    </Container>
  );
};

CoachDetailCard.propTypes = {
  userData: PropTypes.object.isRequired,
  isShowTiming: PropTypes.bool,
};

CoachDetailCard.defaultProps = {
  isShowTiming: true,
  userData: {
    photo: coachDemoImg,
    displayName: "Mackenzie McDonald",
    distance: "0.6 m away",
    lat: "",
    lng: "",
    aboutMe:
      "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis",
    price: 75,
    rating: 5,
    sport: "Tennis",
    timing: [
      {
        date: moment().format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(1, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(2, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(3, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(4, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(5, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
      {
        date: moment().add(7, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM"],
      },
    ],
  },
  searchDateArray: [
    moment(Date.now()),
    moment(moment(Date.now()).add(1, "days")),
    moment(moment(Date.now()).add(2, "days")),
    moment(moment(Date.now()).add(3, "days")),
    moment(moment(Date.now()).add(4, "days")),
    moment(moment(Date.now()).add(5, "days")),
  ],
};
